var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { GalleryActions } from 'src/app/gallery/state/gallery.actions';
import { MatDialogRef } from '@angular/material';
import { GalleryState } from 'src/app/gallery/state/gallery.state';
import { Observable, Subject } from 'rxjs';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { DialogActions } from '../../state/dialog.actions';
export class ImportModelDialogComponent {
    constructor(store, dialogRef, changeDetectorRef) {
        this.store = store;
        this.dialogRef = dialogRef;
        this.changeDetectorRef = changeDetectorRef;
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.results$.subscribe(results => {
            this.changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this.store.dispatch(new GalleryActions.ClearResults());
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    handleSelect(bookmark) {
        if (!bookmark.premium || this.store.selectSnapshot(AuthState.isPremiumUser)) {
            this.store.dispatch(new GalleryActions.SelectBookmark(bookmark));
            this.dialogRef.close(bookmark);
        }
        else {
            this.store.dispatch(new DialogActions.OpenPremiumContent());
        }
    }
}
__decorate([
    Select(GalleryState.getViewMode),
    __metadata("design:type", Observable)
], ImportModelDialogComponent.prototype, "viewMode$", void 0);
__decorate([
    Select(GalleryState.getLoading),
    __metadata("design:type", Observable)
], ImportModelDialogComponent.prototype, "loading$", void 0);
__decorate([
    Select(GalleryState.getSearchResults),
    __metadata("design:type", Observable)
], ImportModelDialogComponent.prototype, "results$", void 0);
__decorate([
    Select(AuthState.isPremiumUser),
    __metadata("design:type", Observable)
], ImportModelDialogComponent.prototype, "isPremiumUser$", void 0);
